import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen } from 'lucide-react';
const chips = ['+300 pág.', '60+ secuencias didácticas', 'Fichas imprimibles', 'Evaluaciones listas', 'Rúbricas CFE', 'Planificación anual', 'Diagnóstico', 'Primer Ciclo', 'Segundo Ciclo', 'Geometría', 'Fracciones', 'Estadística', 'Probabilidad', 'Problemas', 'Numeración', 'Medida'];
const contents = ['Numeración y Sistema Posicional', 'Suma, Resta, Multiplicación y División', 'Fracciones y Decimales', 'Proporcionalidad y Porcentajes', 'Geometría Plana y Espacial', 'Medida y Sistema Métrico', 'Estadística y Probabilidad', 'Álgebra Inicial (6° Grado)', 'Resolución de Problemas', 'Evaluación Formativa y Sumativa'];
export const SystemFeatures = () => {
  return <section className="py-20 bg-white" data-id="element-239">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-240">
        <div className="text-center mb-12" data-id="element-241">
          <div className="inline-block bg-brand-gold/20 text-brand-green font-bold px-4 py-1.5 rounded-full text-sm mb-4" data-id="element-242">
            SISTEMA N°1 EN ARGENTINA
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4" data-id="element-243">
            Para Docentes de Matemática Primaria
          </h2>
          <p className="text-xl text-brand-orange font-semibold" data-id="element-244">
            Sistema completo · 6 Tomos + 6 Bonos · 1° a 6° Grado · Todo
            resuelto.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-245">
          {chips.map((chip, i) => <span key={i} className="flex items-center gap-1.5 bg-brand-green/5 text-brand-green px-4 py-2 rounded-full font-medium border border-brand-green/10" data-id="element-246">
              <CheckCircle2 size={16} className="text-brand-green" data-id="element-247" />
              {chip}
            </span>)}
        </motion.div>

        <div className="bg-cream-dark rounded-2xl p-8 md:p-12 border border-brand-orange/20 shadow-sm text-center mb-12" data-id="element-248">
          <p className="text-xl md:text-2xl font-heading font-semibold text-gray-800" data-id="element-249">
            Funciona desde el lunes en tu aula, ya sea pública, privada o de
            gestión social.
          </p>
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-250">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2 justify-center" data-id="element-251">
            <BookOpen className="text-brand-orange" data-id="element-252" /> Contenidos incluidos:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-253">
            {contents.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="flex items-start gap-3" data-id="element-254">
                <div className="mt-1 bg-brand-orange/20 p-1 rounded-full" data-id="element-255">
                  <div className="w-2 h-2 bg-brand-orange rounded-full" data-id="element-256"></div>
                </div>
                <span className="text-gray-700 font-medium" data-id="element-257">{item}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};